import { render, staticRenderFns } from "./IncluirPercentual.vue?vue&type=template&id=2a8f2928&"
import script from "./IncluirPercentual.vue?vue&type=script&lang=js&"
export * from "./IncluirPercentual.vue?vue&type=script&lang=js&"
import style0 from "./IncluirPercentual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports